import { render, staticRenderFns } from "./favouritePage.vue?vue&type=template&id=11f8bdc5&"
import script from "./favouritePage.vue?vue&type=script&lang=ts&"
export * from "./favouritePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports